import { GlobalAxios } from "../axios/axios-config";
import { ITicketAutomationMacro } from "../models/ticket-automation-macro";
const TICKET_AUTO_INTERNAL_TEMPLATE =
  process.env.REACT_APP_AUTOMATIONS +
  "/api/v1/TicketAutomationInternalTemplateField/";

export const listVariablesInternalTemplateField = (params?: any) => {
  return GlobalAxios.get<ITicketAutomationMacro[]>(
    TICKET_AUTO_INTERNAL_TEMPLATE + "list",
    {
      params: params,
    }
  );
};
